import { AxiosResponse } from 'axios';

import { CertificateI, ConfirmationI } from '../../declarations/interfaces/confirmation';
import { get } from '../api';

export const getConfirmationPageData = async (
  confirmationId: string
): Promise<AxiosResponse<ConfirmationI>> =>
  await get(`/cfc/get-confirmation-page/${confirmationId}/localization`);

export const getCertificateURL = async (refNumber: string): Promise<AxiosResponse<CertificateI>> =>
  await get(`/cfc/certificate/getByReferenceNumber?referenceNumber=${refNumber}`);
